import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Content box of the side panels (filter drawer, „Pridané do košíka“): from `md` a full-height
 * panel at the right edge (24 px left radius) sliding in from the right; on phones a bottom sheet
 * 44 px below the top of the screen with an 18 px top radius (Figma 60438:87781, 60460:111802)
 * sliding up. The width from `md` is the caller's.
 */
export const SHEET = cn(
  'fixed inset-x-0 bottom-0 top-11 z-[200] flex flex-col overflow-hidden rounded-t-[18px] bg-white shadow-dropdown focus:outline-none',
  'data-[state=open]:animate-in motion-reduce:animate-none max-md:data-[state=open]:slide-in-from-bottom',
  'md:inset-x-auto md:inset-y-0 md:right-0 md:rounded-l-[24px] md:rounded-tr-none md:data-[state=open]:slide-in-from-right',
);
